const FOOTER = {
  NAV_SOURCE: 'footer nav',
  ORDER_PRIMARY: 'primary',
  ORDER_SECONDARY: 'secondary',
};

export { FOOTER as default };
